import { ISnLayoutConfig } from '../interfaces';
import { SnLayoutAppbarConfig } from '../models';

export function snLayoutAppbarConfigFactory(config: ISnLayoutConfig): SnLayoutAppbarConfig {
  return new SnLayoutAppbarConfig(config.appbar);
}
